import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function getAllProducto_terminado() {
    console.log("Hola");
    const Producto_terminadoDB =  [];
    //console.log(valor);
    const collectionRef = collection(db, "Almacen_empaque/Producto"+" "+"terminado/Productos/".replace(/ /g, ""));
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      Producto_terminadoDB.push(doc.data());
    });
    return Producto_terminadoDB;
    

}
